import styled from "styled-components";

import { TEXT_SECONDARY } from "../../../../colors";
import { Body } from "../../../../typography";

export const Text = styled(Body).attrs({ as: "span" })`
  color: ${TEXT_SECONDARY};
`;
